module.exports = __webpack_public_path__ + "static/media/banner-full.7e542b0e.png";